export const SIDEBAR_MENU_BUTTON_STYLE_OVERRIDES =
  'gap-3 has-[>svg]:px-4 group-data-[state=collapsed]:px-2.5 group-data-[state=collapsed]:has-[>svg]:px-2.5 justify-start h-10 group-data-[state=collapsed]:w-10 ';
